<template>
  <v-card flat>
    <v-col cols="12" class="px-0">
      <v-btn color="primary" icon @click="handleBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="text-h6 mr-2" style="vertical-align: middle">
        {{ $t('message.pages.drm.watermark') }}
      </span>
    </v-col>

    <v-card-text
      v-if="!drmGroupsLoading"
      class="overflow-y-auto ma-0 pa-0"
      flat
      style="height: 350px"
      width="100%"
    >
      <v-row v-if="drmGroups.length" no-gutters>
        <v-col cols="12">
          <v-card
            v-for="(group, i) in drmGroups"
            class="d-flex flex-row align-center"
            :key="i"
            flat
            height="47"
            width="100%"
            :style="
              drmGroups.length > 1
                ? 'border-bottom: 1px solid #EDEEF1; border-radius: 0px !important'
                : ''
            "
          >
            <v-row no-gutters>
              <v-card
                class="d-flex align-center justify-center mr-1"
                flat
                color="background"
              >
                <v-btn icon @click="handleActiveGroup(group)">
                  <v-card
                    class="d-flex align-center justify-center elevation-0 rounded-pill"
                    width="20px"
                    height="20px"
                    :color="
                      group.isActive
                        ? '#3F55EE'
                        : $vuetify.theme.dark
                        ? '#000000'
                        : '#FFFFFF'
                    "
                    :style="
                      group.isActive
                        ? ''
                        : $vuetify.theme.dark
                        ? 'border: 2px solid #52577A'
                        : 'border: 2px solid #D0D1D9'
                    "
                  >
                    <v-card
                      v-if="group.isActive"
                      :color="
                        group.isActive
                          ? '#FFFFFF'
                          : !$vuetify.theme.dark
                          ? '#000000'
                          : '#FFFFFF'
                      "
                      width="10px"
                      height="10px"
                      flat
                      class="rounded-pill"
                    ></v-card>
                  </v-card>
                </v-btn>
              </v-card>
              <v-col class="d-flex align-center justify-start">
                <span
                  :title="group.name"
                  class="text-truncate"
                  :style="`max-width: ${nameSizing}px`"
                  >{{ group.name }}</span
                >
              </v-col>
              <v-card
                v-if="!group.value"
                class="d-flex align-center justify-end mr-3"
                flat
                color="background"
                width="125px"
              >
                <v-card
                  :color="`${
                    $vuetify.theme.dark
                      ? group.webhook_source_name
                        ? '#363949'
                        : '#1B5E20'
                      : group.webhook_source_name
                      ? '#ABADBA'
                      : '#C8E6C9'
                  }`"
                  class="statusText rounded-pill px-2 py-0"
                  flat
                >
                  <span
                    :style="`${
                      $vuetify.theme.dark
                        ? group.webhook_source_name
                          ? 'color: #666D99'
                          : 'color: #DCEFDD'
                        : group.webhook_source_name
                        ? 'color: #EDEEF1'
                        : 'color: #174F1B'
                    }`"
                    class="caption"
                  >
                    {{
                      group.webhook_source_name
                        ? group.webhook_source_name.charAt(0).toUpperCase() +
                          group.webhook_source_name.slice(1)
                        : 'API'
                    }}
                  </span>
                </v-card>
              </v-card>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-else no-gutters>
        <v-col cols="12">
          <span>
            {{ $t('message.pages.drm.updateGroup.text1') }}
          </span>
        </v-col>
        <v-col cols="12" class="my-6">
          <span>
            <b>{{ $t('message.pages.drm.updateGroup.text2') }}</b>
          </span>
        </v-col>
        <v-col cols="12">
          <v-btn color="primary" @click="handleActiveDrm">
            <v-icon>mdi-cog</v-icon
            >{{ $t('message.pages.drm.updateGroup.activeDRM') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else style="height: 350px">
      <v-row no-gutters align="center" justify="center">
        <loading-logo :value="200" />
      </v-row>
    </v-card-text>
    <v-card-actions class="pl-8 py-4" v-if="drmGroups.length">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        :loading="isFetching"
        :disabled="isFetching || drmGroupsLoading || checkIfHasChanged"
        width="150"
        @click="handleConfirm"
      >
        <span class="px-5">{{ $t('message.actions.save') }}</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import drmApi from '@/services/drmApi'
import LoadingLogo from '@/components/LoadingLogo.vue'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'

export default {
  name: 'DrmGroupUpdateList',
  components: {
    LoadingLogo,
  },
  data: () => ({
    open: false,
    isFetching: false,
    drmGroupsLoading: false,
    drmGroups: [],
    startValueDrmGroups: [],
    db: null,
    isDrmActive: true,
    initialActiveItem: null,
  }),
  props: {
    selectedItem: Object,
    handleBack: {
      type: Function,
      required: true,
    },
    hasEdit: {
      type: Array,
      required: false,
    },
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    nameSizing() {
      let width = window.innerWidth
      if (this.isMobileBreakpoint) {
        return '135'
      }
      if (width > 1600) {
        return '400'
      } else if (width > 1250) {
        return '220'
      } else {
        return '150'
      }
    },
    checkIfHasChanged() {
      return _.isEqual(this.startValueDrmGroups, this.drmGroups)
    },
  },
  async created() {
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    await this.getDrmGroups()
    this.setInfo()
    this.open = true
  },
  beforeDestroy() {
    this.$root.$off('drmModalDashboard')
  },
  updated() {
    if (this.hasEdit)
      this.hasEdit[0] =
        this.isFetching || this.drmGroupsLoading || this.checkIfHasChanged
  },
  methods: {
    ...mapActions('user', ['editFolder']),
    async handleActiveDrm() {
      this.drmGroupsLoading = true
      try {
        await drmApi.activateDrm()
        this.getDrmGroups()
      } catch (e) {
        console.log('e', e)
      }
    },
    async getDrmGroups() {
      this.isDrmActive = true
      this.drmGroupsLoading = true
      try {
        let ret = await drmApi.getDrmGroups()
        this.startValueDrmGroups = ret.data
        this.drmGroups = ret.data
      } catch (error) {
        this.drmGroupsLoading = false
        if (error.response.data.errMsg.includes('Drm is not active')) {
          this.isDrmActive = false
          return
        }
        setTimeout(() => {
          this.getDrmGroups()
        }, 2000)
      }
      this.drmGroupsLoading = false
    },
    handleActiveGroup(activateGroup) {
      if (activateGroup.isActive) return
      this.drmGroups = this.drmGroups.map((group) => {
        if (group.id === activateGroup.id) {
          group.isActive = !group.isActive
        } else if (group.isActive) {
          group.isActive = false
        }
        return group
      })
    },
    setInfo() {
      if (this.selectedItem.drm_group_ids) {
        let fixedGroups = this.drmGroups.map((group) => {
          let foundGroup = this.selectedItem.drm_group_ids.find(
            (el) => el.drm_group_id === group.id
          )
          return { ...group, isActive: !!foundGroup }
        })
        this.startValueDrmGroups = JSON.parse(JSON.stringify(fixedGroups))
        this.drmGroups = JSON.parse(JSON.stringify(fixedGroups))
      } else {
        let fixedGroups = this.drmGroups.map((group) => ({
          ...group,
          isActive: false,
        }))
        this.startValueDrmGroups = JSON.parse(JSON.stringify(fixedGroups))
        this.drmGroups = JSON.parse(JSON.stringify(fixedGroups))
      }
      this.drmGroups.push({
        name: this.$i18next.t('message.pages.drmModalDashboard.none'),
        value: 'none',
        isActive: !this.selectedItem.drm_group_ids,
      })
      this.initialActiveItem = this.drmGroups.find((item) => item.isActive)
    },
    async handleConfirm() {
      this.isFetching = true
      this.getNewGroups()
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async removeFromAllGroups() {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'delete',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'delete',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      let removingIds = this.selectedItem.drm_group_ids.map(
        (item) => item.drm_group_id
      )
      for (let removingId of removingIds) {
        try {
          await drmApi.drmUpdateVideos(removingId, modifiedData)
          this.selectedItem.drm_group_ids =
            this.selectedItem.drm_group_ids.filter(
              (item) => item.drm_group_id != removingId
            )
          if (!this.selectedItem.drm_group_ids.length)
            delete this.selectedItem['drm_group_ids']
        } catch (e) {
          console.log('e', e)
        }
      }
      this.updateInPage()
      this.isFetching = false
    },
    getNewGroups() {
      let noGroup = this.drmGroups.find((group) => group.value === 'none')
      if (noGroup.isActive) {
        if (this.initialActiveItem?.value === 'none') {
          return
        }
        this.removeFromAllGroups()
        return
      }
      let startActiveArray = this.startValueDrmGroups.map(
        (group) => group.isActive
      )
      let newActiveArray = this.drmGroups.map((group) => group.isActive)
      let arrayIndexes = []
      for (let i = 0; i < startActiveArray.length; i++) {
        if (startActiveArray[i] !== newActiveArray[i]) {
          let indexedValue = i
          arrayIndexes.push(indexedValue)
        }
      }
      this.getGroupChanges(arrayIndexes)
    },
    async getGroupChanges(indexes) {
      let toBeAddedGroups = []
      let toBeRemovedGroups = []
      for (let index of indexes) {
        let changedGroup = this.drmGroups[index]
        if (this.selectedItem.drm_group_ids) {
          let findGroup = this.selectedItem.drm_group_ids.find(
            (group) => group.drm_group_id === changedGroup.id
          )
          if (findGroup) {
            toBeRemovedGroups.push(changedGroup)
          } else {
            toBeAddedGroups.push(changedGroup)
          }
        } else {
          toBeAddedGroups.push(changedGroup)
        }
      }
      for (let group of toBeRemovedGroups) {
        await this.removeItemFromGroup(group)
      }
      for (let group of toBeAddedGroups) {
        await this.addItemFromGroup(group)
      }
      this.updateInPage()
      if (!this.selectedItem.name) {
        this.isFetching = false
      }
    },
    async addItemFromGroup(group) {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'increment',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'increment',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      try {
        await drmApi.drmUpdateVideos(group.id, modifiedData)
        let newObj = {
          active: group.active,
          drm_group_id: group.id,
        }
        if (this.selectedItem.drm_group_ids) {
          this.selectedItem.drm_group_ids.push(newObj)
        } else {
          this.selectedItem.drm_group_ids = [newObj]
        }
      } catch (e) {
        console.log('e', e)
      }
    },
    async removeItemFromGroup(group) {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'delete',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'delete',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      try {
        await drmApi.drmUpdateVideos(group.id, modifiedData)
        this.selectedItem.drm_group_ids =
          this.selectedItem.drm_group_ids.filter(
            (item) => item.drm_group_id != group.id
          )
      } catch (e) {
        console.log('e', e)
      }
    },
    updateInPage() {
      if (this.selectedItem.name) {
        this.updateFolderDrmGroups(this.selectedItem)
        this.$root.$emit('updateFolderVideosPage', this.selectedItem)
      } else {
        if (this.$route.params.id) {
          this.updateIndexedVideo(this.selectedItem)
        } else {
          this.$root.$emit('updateVideoVideosPage', this.selectedItem)
        }
      }
    },
    async updateIndexedVideo(video) {
      await window.db.videos.update(video.id, video)
    },
    updateFolderDrmGroups(folder) {
      this.editFolder(folder)
    },
    handleClose() {
      this.open = false
    },
  },
}
</script>
